import {observable, observe, action, makeAutoObservable} from 'mobx';
import * as Api from '@/utils/api/api';

class ShopStore {
  companyName = '';
  officialWebsite = '';
  saleroom = '';
  hasExperience = false;
  shopWebsite = '';
  personNumber = '';
  goodsNumber = 0;
  predictAveragePrice = 0;
  stock = 0;
  warehouseAddress = '';
  generalLogistics = '';
  erpType = 0;
  thirdPartnarCompany = '';
  selectOurWarehouse = false;
  selectOurLogistics = false;
  openSaleQualification = false;
  receivedInvite = 0;

  goodsNumberList = [];
  predictAveragePriceList = [];
  stockList = [];
  erpTypeList = [];
  receivedInviteList = [];

  constructor() {
    makeAutoObservable(this)
  }

   async fetchGoodsNumberList() {
    try {
      const { list } = await Api.goodsNumberList();

      this.goodsNumberList = list.map(item => {
        const { id: value, numberScope: label } = item;

        return {
          value,
          label
        };
      });
      this.predictAveragePriceList = list.map(item => {
        const { id: value, numberScope: label } = item;

        return {
          value,
          label
        };
      });
    } catch (error) {}
  }

  async fetchStockList() {
    try {
      const { list } = await Api.stockList();

      this.stockList = list.map(item => {
        const { id: value, warehouse: label } = item;

        return {
          value,
          label
        };
      });
    } catch (error) {}
  }

  async fetchErpTypeList() {
    try {
      const { list } = await Api.erpTypeList();

      this.erpTypeList = list.map(item => {
        const { id: value, erp: label } = item;

        return {
          value,
          label
        };
      });
    } catch (error) {}
  }

   async fetchReceivedInvitedList() {
    try {
      const { list } = await Api.receivedInviteList();

      this.receivedInviteList = list.map(item => {
        const { id: value, stands: label } = item;

        return {
          value,
          label
        };
      });
    } catch (error) {}
  }

   fetchData() {
    this.fetchGoodsNumberList();
    this.fetchStockList();
    this.fetchErpTypeList();
    this.fetchReceivedInvitedList();
  }
}

let shop = new ShopStore();

export default shop;
